module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": (_vm.tabela_preco ? _vm.tabela_preco.credenciada_nome + ' - VALOR TOTAL DOS EXAMES: R$ ' + _vm.tabela_preco.valor_total : ''),
      "width": "90%"
    }
  }, [(_vm.tabela_preco) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.parent.loadingExame),
      expression: "parent.loadingExame"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    attrs: {
      "type": "warning",
      "description": "Disponibilizamos abaixo a lista dos exames obrigatórios no PCMSO. Você pode escolher em qual Parceiro o exame deve ser feito.",
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('ed-table', {
    staticClass: "mt-2",
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "tableFooter": _vm.tableFooter,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b0f4b50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/credenciada/exame.vue
// module id = 1453
// module chunks = 45